// extracted by mini-css-extract-plugin
module.exports = {"container":"eDANCj","title":"YD4A0M","content":"EggZAg"};